export default {
  STATUS: {
    WAITING: 0,
    CANCLE: 1,
    PREPARING: 2,
    READY: 3,
  },
};
